export enum AnalyticsSections {
  ORDERS = 'orders',
  CERTS = 'certs',
  RETURNS_ZIP = 'returns_zip',
  ORDER_SIDES = 'order_sides',
  REPAIR_MODELS = 'repair_models',
  LEADS = 'leads',
  REPAIR_TYPES = 'repair_types',
  RESULT_SERVICE_ACTIVITY = 'result_service_activity',
  CREDIT_LINE = 'credit_line',
}
